"use client";
/**
 * 배포 루트(".") 엔트리 — 구 @lumir-company/editor 루트 표면과 1:1 호환.
 *
 * 소비처(Lumir-ERP 등)는 `import("@lumir-company/editor").then(m => m.LumirEditor)` 로
 * 루트에서 React 컴포넌트를 가져가므로, 루트가 React 래퍼를 포함해야 한다.
 * react-free 코어만 필요하면 "./core" 서브패스를 사용한다(react 미로드).
 *
 *   루트(".")   = core 전체 + LumirEditor/FloatingMenu(react) + 구 전용 스텁
 *   "./core"    = react-free 유틸/직렬화/mountLumirEditor
 *   "./react"   = 루트와 동일 표면(구 vanilla 서브패스 하위호환)
 */
export * from "./index.js";
export { LumirEditor, FloatingMenu, FontSizeButton, default } from "./react.js";

/**
 * 호환 스텁 — 구 패키지의 BlockNote 커스텀 스타일 스펙/스키마 export.
 * vanilla 에는 BlockNote 런타임이 없어 실체가 없다. import 가 undefined 로 깨지지 않도록
 * 마커 객체를 둔다(스키마 조립 등 실제 사용은 불가 — fontSize 는 에디터에 내장됨).
 */
export const FontSize = { __compat: "lumir-editor", note: "fontSize style is built-in; spec object is a stub" };
export const EditorSchema = { __compat: "lumir-editor", note: "schema is internal; stub for import compatibility" };
